import { useEffect, useRef } from 'react';
import { VariableSizeList } from 'react-window';

/**
 * Implementation from https://mui.com/material-ui/react-autocomplete/#virtualization
 * VariableSizeList caches offsets and measurements for each index for performance purposes.
 * This hook clears that cached data for all items after (and including) the specified index.
 * It should be called whenever a item's size changes.
 * By default the list will automatically re-render after the index is reset.
 * @param data
 */
export function useResetCache(data: number) {
  const ref = useRef<VariableSizeList>(null);
  // biome-ignore lint/correctness/useExhaustiveDependencies: exception
  useEffect(() => {
    if (ref.current != null) {
      ref.current.resetAfterIndex(0, true);
    }
  }, [data]);
  return ref;
}
